<template>
  <table class="rights-table">
    <thead>
      <tr>
        <th class="th-category">功能类别</th>
        <th class="th-feature">核心功能点</th>
        <th class="th-trial">
          <span class="th-trial-inner">
            <img class="th-icon" :src="iconFree" alt="" />
            <span class="th-trial-text">免费版</span>
          </span>
        </th>
        <th class="th-pro">
          <span class="th-pro-inner">
            <img class="th-icon" :src="iconPro" alt="" />
            <span class="th-pro-text">专业版</span>
          </span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in tableRows" :key="index">
        <td
          v-if="row.showCategory"
          :rowspan="row.categorySpan"
          class="td-category"
        >
          {{ row.category }}
        </td>
        <td class="td-feature">{{ row.feature }}</td>
        <td class="td-trial" :class="{ 'is-unsupported': !row.trial }">
          {{ row.trial || "不支持" }}
        </td>
        <td class="td-pro">{{ row.pro }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
/**
 * 9 大权益对比表（套餐购买页 与 专业版权益页 共用）
 * 数据来源：getProPlanRights，需先转换为 [{category, feature, trial, pro}]
 */
export default {
  name: "RightsTable",
  props: {
    rights: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      iconFree: require("@/assets/images/pro-plan/plan/plan-icon-free.png"),
      iconPro: require("@/assets/images/pro-plan/plan/plan-icon-pro.png"),
    };
  },
  computed: {
    // 计算每个分类的合并行数，只在分类首行渲染单元格
    tableRows() {
      const rows = [];
      const list = this.rights || [];
      let lastCategory = null;
      list.forEach((item) => {
        const isFirst = item.category !== lastCategory;
        lastCategory = item.category;
        rows.push({ ...item, showCategory: isFirst });
      });
      // 回填 rowspan
      rows.forEach((row, index) => {
        if (!row.showCategory) return;
        let span = 1;
        for (let i = index + 1; i < rows.length; i++) {
          if (rows[i].category === row.category) span++;
          else break;
        }
        row.categorySpan = span;
      });
      return rows;
    },
  },
};
</script>

<style lang="scss" scoped>
.rights-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid #e0e5ef;
  border-radius: 10px;
  overflow: hidden;
  table-layout: fixed;
  th,
  td {
    box-sizing: border-box;
    text-align: center;
    vertical-align: middle;
    padding: 13px 12px;
  }
  thead th {
    // 设计稿表头（table/header 组件）：padding 8px 12px 9px + 行高 23 → 高 40。
    // 原用 body 的 13px padding 会变成 49px，比设计稿高 9px（禅道 Bug#23427-4）
    padding: 8px 12px 9px;
    background: #f5f7fa;
    font-family: "Alimama ShuHeiTi", "Microsoft YaHei";
    font-weight: 700;
    font-size: 16px;
    line-height: 23px;
    color: #1d2328;
  }
  .th-category {
    width: 159px;
  }
  .th-feature {
    width: 243px;
  }
  // 深色表头条：底色 + 中心辉光 + 纹理线条（设计稿 #1896:153 / #1896:200 三层）
  // 多层背景：先写的在上层；background-color 最底
  .th-trial {
    width: 291px;
    padding: 0;
    border-radius: 12px 12px 0 0;
    background-color: #031f12;
    background-image: url("~@/assets/images/pro-plan/plan/rights-header-texture-free.svg"),
      radial-gradient(
        334px 90px at 146px -12px,
        rgba(15, 168, 123, 0.4) 0%,
        rgba(15, 188, 136, 0) 100%
      );
    background-repeat: no-repeat;
    background-size: 397.99px 105.83px, 334px 90px;
    background-position: -30.77px -53.33px, -21px -57px;
  }
  .th-trial-inner {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    height: 40px;
  }
  .th-trial-text {
    font-size: 16px;
    font-weight: 700;
    background: linear-gradient(180deg, #65cc94 21%, rgba(101, 204, 148, 0) 56%),
      radial-gradient(circle at 54% 60%, #6dbe73 0%, #64c892 69%, #caf8f8 100%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }
  .th-pro {
    width: 350px;
    padding: 0;
    border-radius: 12px 12px 0 0;
    background-color: #1a1719;
    background-image: url("~@/assets/images/pro-plan/plan/rights-header-texture-pro.svg"),
      linear-gradient(90deg, #1a1719 0%, #333332 100%),
      radial-gradient(
        334px 90px at 175px -12px,
        rgba(223, 186, 117, 0.22) 0%,
        rgba(217, 136, 54, 0) 100%
      );
    background-repeat: no-repeat, no-repeat, no-repeat;
    background-size: 478.68px 105.83px, 100% 100%, 334px 90px;
    background-position: -37.01px -53.33px, 0 0, 8px -57px;
  }
  .th-pro-inner {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    height: 40px;
  }
  .th-pro-text {
    font-size: 16px;
    font-weight: 700;
    background: conic-gradient(
      from 96deg at 27% 92%,
      #f8da72 51%,
      #f7cb3b 59%,
      #fdfac1 75%,
      #eba203 84%,
      #f5c330 90%,
      #eeedd4 97%
    );
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }
  // 表头图标为设计稿切图
  .th-trial .th-icon {
    width: 22px;
    height: 20px;
  }
  .th-pro .th-icon {
    width: 18px;
    height: 18px;
  }
  tbody {
    td {
      font-family: "Alibaba PuHuiTi 2.0", "Microsoft YaHei";
      font-size: 16px;
      line-height: 23px;
      color: #41536a;
      border-top: 1px solid #ebeef5;
    }
    .td-category {
      background: #fff;
      border-right: 1px solid #ebeef5;
      color: #41536a;
    }
    .td-feature {
      background: #fff;
    }
    .td-trial {
      background: #f2fffb;
      color: #0fa87b;
      font-size: 14px;
      border-bottom: 1px solid #e8f6f2;
    }
    .td-trial.is-unsupported {
      color: #acb6c7;
    }
    .td-pro {
      background: #fefaee;
      color: #996c0a;
      font-size: 14px;
    }
    tr:last-child .td-trial,
    tr:last-child .td-pro {
      border-bottom: none;
    }
  }
}
</style>
